<ng-template [ngIf]="camera" [ngIfElse]="placeholder">
  <mat-card>
    <mat-card-header class="widget-header" *ngIf="!widget.meta.hideTitle">
      <mat-card-title
        *ngIf="!changeTitle; else editTitleWidget"
        [matTooltip]="'dashboard.operational.widgets.doubleClickToEditTitle' | t"
        matTooltipPosition="above"
        (dblclick)="editTitle()"
        class="editTitle"
        >{{ widget.name }}
        <sn-icon size="xs">edit</sn-icon>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="widgetPlayer">
        <button
          mat-icon-button
          *ngIf="canChange"
          class="changeCamera"
          icon="swap_horiz"
          [matTooltip]="'dashboard.operational.widgets.changeCamera' | t"
          matTooltipPosition="before"
          (click)="openCameraDialog()"
        >
          <mat-icon>swap_horiz</mat-icon>
        </button>
        <sn-audit-camera-stream-view
          [autoplay]="true"
          [camera]="camera"
          [controls]="true"
          [actions]="false"
          [allowTimeout]="false"
        >
        </sn-audit-camera-stream-view>
      </div>
    </mat-card-content>
  </mat-card>
</ng-template>

<ng-template #placeholder>
  <mat-card>
    <mat-card-header *ngIf="!widget.meta.hideTitle">
      <mat-card-title
        *ngIf="!changeTitle; else editTitleWidget"
        [matTooltip]="'dashboard.operational.widgets.doubleClickToEditTitle' | t"
        matTooltipPosition="above"
        (dblclick)="editTitle()"
        >{{ widget.name }}
        <sn-icon size="xs">edit </sn-icon>
      </mat-card-title>
    </mat-card-header>
    <sn-empty-state icon="videocam" [title]="'dashboard.operational.widgets.chooseCameraToView' | t" class="placeholder">
      <button mat-flat-button *ngIf="canChange" color="accent" (click)="openCameraDialog()">
        {{ 'common.selectCamera' | t }}
      </button>
    </sn-empty-state>
  </mat-card>
</ng-template>

<ng-template #editTitleWidget>
  <sn-form-edit-title
    [widget]="widget"
    [viewId]="viewId"
    (title)="setTitle($event)"
    (updateTitle)="setUpdateTitle($event)"
  ></sn-form-edit-title>
</ng-template>
